import { render, staticRenderFns } from "./TaskDashboardWidget.vue?vue&type=template&id=588f266a"
import script from "./TaskDashboardWidget.vue?vue&type=script&lang=js"
export * from "./TaskDashboardWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports